import { ConfigurationFeatures } from '../ConfigurationFeatures';
import { CONFIGURATIONS_MIMETYPE_OPENED, } from '../ConfigurationsSegmentEvents';
import './Mimetypes.scss';
export class MimeTypeController {
    static $inject = ['LoadingService', 'ConfigurationsService', 'CallerConfigurationService', 'SegmentService', '$state', '$translate', 'application', 'ngToast', 'SharedToastsService'];
    constructor(LoadingService, ConfigurationsService, CallerConfigurationService, SegmentService, $state, $translate, application, ngToast, SharedToastsService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.ConfigurationsService = ConfigurationsService;
        this.CallerConfigurationService = CallerConfigurationService;
        this.SegmentService = SegmentService;
        this.$state = $state;
        this.$translate = $translate;
        this.application = application;
        this.ngToast = ngToast;
        this.SharedToastsService = SharedToastsService;
        this.cardStates = {};
        this.allChecked = false;
        this.useConfigurationApplicationSet = false;
        this.useConfigurationApplicationGet = false;
        this.showInfo = false;
        this.showCreationModal = false;
        this.formsPurpose = '';
        this.isCreatingKey = false;
        this.mimeTypeChecked = '';
    }
    async $onInit() {
        const isMimeTypeManagementEnable = await ConfigurationFeatures.isMimeTypeManagementEnable();
        this.useConfigurationApplicationSet = await ConfigurationFeatures.isConfigurationDomainOnAdvancedConfigurationPropertiesSetEnabled();
        this.useConfigurationApplicationGet = await ConfigurationFeatures.isConfigurationDomainOnAdvancedConfigurationPropertiesGetEnabled();
        if (!isMimeTypeManagementEnable) {
            this.$state.go('auth.application.list');
        }
        await this.trackViewOpened();
        await this.query();
        this.$translate(['extensions.page_before', 'extensions.current_page']).then((translations) => {
            this.breadcrumbItems = [
                { label: translations['extensions.page_before'], href: '/' },
                { label: translations['extensions.current_page'] },
            ];
        });
        this.initializeCheckboxListeners();
    }
    async trackViewOpened() {
        this.SegmentService.createApplicationTrack({
            trackEvent: CONFIGURATIONS_MIMETYPE_OPENED,
        });
    }
    async query() {
        this.isLoading = true;
        await this.getConfigurations();
        const extensions = this.mimeTypeChecked.split(';');
        const checkboxlist = Array.from(document.querySelectorAll('bds-checkbox'));
        checkboxlist.forEach((checkbox, index) => {
            checkbox.checked = !extensions.includes(checkbox.getAttribute('value'));
        });
        this.updateCardStates();
        this.isLoading = false;
    }
    async getConfigurations() {
        const configurationsResult = (await this.CallerConfigurationService.get(this.application.shortName + '@msging.net', this.useConfigurationApplicationGet)).items.map((o) => {
            return { domain: o.owner, key: o.name, value: o.value };
        });
        const extensionsCheckeds = configurationsResult.filter(o => o.key == 'MimeTypeRestrictionItems');
        if (extensionsCheckeds.length > 0) {
            this.mimeTypeChecked = extensionsCheckeds[0].value;
        }
        else {
            this.mimeTypeChecked = '';
        }
    }
    async save() {
        this.applicationForm.$setPristine();
        try {
            const checkboxElements = document.querySelectorAll('bds-checkbox');
            const checkboxlist = Array.from(checkboxElements);
            this.MimeTypeNotAlowed = '';
            const resource = {};
            const domain = 'postmaster@media.msging.net';
            const keyMimeTypes = 'MimeTypeRestrictionItems';
            checkboxlist.forEach((checkbox, index) => {
                if (!checkbox.checked) {
                    const elementAttribute = checkbox.getAttribute('value');
                    this.MimeTypeNotAlowed = this.MimeTypeNotAlowed + elementAttribute + ';';
                }
            });
            resource[keyMimeTypes] = this.MimeTypeNotAlowed;
            await this.ConfigurationsService.set(domain, resource, undefined, this.useConfigurationApplicationSet);
            const successMessage = await this.$translate('utils.successMsg.8');
            this.ngToast.success(successMessage);
        }
        catch (err) {
            const errorMessage = await this.$translate('utils.errorMsg.6');
            this.ngToast.danger(errorMessage);
        }
        finally {
            this.$state.reload();
            this.LoadingService.stopLoading();
        }
    }
    toggleCheckboxes(cardId) {
        const checkboxes = document.querySelectorAll(`bds-card[card-id="${cardId}"] bds-checkbox`);
        const allChecked = Array.from(checkboxes).every((checkbox) => checkbox.checked);
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked !== !allChecked) {
                checkbox.toggle();
            }
        });
        this.updateCardStates();
    }
    toggleAllCheckboxes() {
        const checkboxes = document.querySelectorAll('bds-checkbox');
        const allChecked = Array.from(checkboxes).every((checkbox) => checkbox.checked);
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked !== !allChecked) {
                checkbox.toggle();
            }
        });
        this.allChecked = allChecked;
        this.updateCardStates();
    }
    updateCardStates() {
        const cards = document.querySelectorAll('bds-card');
        cards.forEach((card) => {
            const cardId = card.getAttribute('card-id');
            const checkboxes = card.querySelectorAll('bds-checkbox');
            const allChecked = Array.from(checkboxes).every((checkbox) => checkbox.checked);
            this.cardStates[cardId] = allChecked;
        });
        const checkboxes = document.querySelectorAll('bds-checkbox');
        const allChecked = Array.from(checkboxes).every((checkbox) => checkbox.checked);
        this.allChecked = allChecked;
    }
    initializeCheckboxListeners() {
        const checkboxlist = Array.from(document.querySelectorAll('bds-checkbox'));
        checkboxlist.forEach((checkbox) => {
            checkbox.addEventListener('bdsChange', () => {
                this.onCheckboxChange();
            });
        });
    }
    onCheckboxChange() {
        this.updateCardStates();
    }
    resetForm() {
        this.query();
    }
}
MimeTypeController.$inject = ['LoadingService', 'ConfigurationsService', 'CallerConfigurationService', 'SegmentService', '$state', '$translate', 'application', 'ngToast', 'SharedToastsService'];
